
import { Vue } from "vue-class-component";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase";
export default class OnboardingForms extends Vue {
  beforeMount() {
    const id: any = this.$route.params.id;
    getDoc(doc(db, "/form_data" + "/website_design" + "/submitted_forms", id)).then((DocSnap) => {
      if (DocSnap.exists()) {
        this.formData = DocSnap.data();
      }
    })
  }
  formData: any = {};
  loading = true;
  openLink(file: any) {
    window.open(file);
  }
  openSocialLink(link: any) {
    window.open(link);
  }
}
